/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  var LANG_ATTR = 'data-lang-split';
  var HEBREW_CODE_POINT = new RegExp('[\\u0590-\\u05FF\\uFB1D-\\uFB4F]');
  var LATIN_CODE_POINT = new RegExp('[A-Za-z\\u00C0-\\u024F]');
  var SKIP_TAGS = ['SCRIPT', 'STYLE', 'TEXTAREA', 'INPUT', 'SELECT', 'NOSCRIPT', 'TEMPLATE', 'SVG'];

  function detectScript(char) {
    if (HEBREW_CODE_POINT.test(char)) return 'he';
    if (LATIN_CODE_POINT.test(char)) return 'en';
    return null;
  }

  // Groups consecutive characters of the same script into one run each, so that a
  // multi-word Hebrew (or English) sentence stays inside a single span instead of
  // being broken up per word. Neutral characters (spaces, digits, punctuation) join
  // whichever run they're already inside instead of starting a run of their own.
  function splitRuns(text) {
    var runs = [];
    var currentScript = null;
    var currentText = '';

    for (var i = 0; i < text.length; i++) {
      var char = text[i];
      var script = detectScript(char);

      if (script === null || script === currentScript || currentScript === null) {
        currentScript = script || currentScript;
        currentText += char;
        continue;
      }

      runs.push({ script: currentScript, text: currentText });
      currentScript = script;
      currentText = char;
    }

    if (currentText) {
      runs.push({ script: currentScript || 'en', text: currentText });
    }

    return runs;
  }

  function shouldSkip(node) {
    while (node) {
      if (node.nodeType === 1) {
        if (SKIP_TAGS.indexOf(node.tagName) !== -1 || node.hasAttribute(LANG_ATTR) || node.isContentEditable) {
          return true;
        }
      }
      node = node.parentNode;
    }
    return false;
  }

  function wrapTextNode(textNode) {
    var text = textNode.nodeValue;
    if (!text || !text.trim() || shouldSkip(textNode.parentNode)) return;

    var runs = splitRuns(text);

    var fragment = document.createDocumentFragment();
    runs.forEach(function (run) {
      var span = document.createElement('span');
      span.setAttribute(LANG_ATTR, run.script);
      span.className = run.script === 'he' ? 'lang-he' : 'lang-en';
      span.textContent = run.text;
      fragment.appendChild(span);
    });

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function collectTextNodes(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim() || shouldSkip(node.parentNode)) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var textNodes = [];
    var current;
    while ((current = walker.nextNode())) {
      textNodes.push(current);
    }

    return textNodes;
  }

  // Wrapping every text node on the page in one synchronous pass is a long-enough main-thread
  // task to read as a frozen page in webviews that run JS without a JIT (Instagram/Facebook's
  // in-app browser disables it). Spreading the same work over idle time slices lets the page
  // stay responsive while it catches up, instead of blocking once at load.
  var queue = [];
  var flushScheduled = false;
  var FALLBACK_BATCH_SIZE = 40;

  function flushQueue(deadline) {
    var processed = 0;

    // Process at least one node per invocation so a starved idle deadline (didTimeout with no
    // time left) still makes forward progress instead of rescheduling forever without doing work.
    while (queue.length) {
      wrapTextNode(queue.shift());
      processed++;
      if (deadline ? deadline.timeRemaining() <= 0 : processed >= FALLBACK_BATCH_SIZE) break;
    }

    flushScheduled = false;
    if (queue.length) scheduleFlush();
  }

  function scheduleFlush() {
    if (flushScheduled) return;
    flushScheduled = true;

    if ('requestIdleCallback' in window) {
      requestIdleCallback(flushQueue, { timeout: 500 });
    } else {
      setTimeout(function () { flushQueue(null); }, 0);
    }
  }

  function processRoot(root) {
    queue = queue.concat(collectTextNodes(root));
    scheduleFlush();
  }

  function init() {
    processRoot(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            processRoot(node);
          } else if (node.nodeType === 3) {
            queue.push(node);
            scheduleFlush();
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
